<template>
    <div class="bot-info inline" justify="between">
        <div class="paginator inline" v-show="count > 0">
            <div v-if="paginator.current > 1" @click="paginator.current--">Пред</div>
            <p>Страница</p>
            <select v-model="paginator.current">
                <option :value="item" v-for="(item, index) of paginator.max" :key="index">{{ item }}</option>
            </select>
            <div v-if="paginator.current < paginator.max" @click="paginator.current++">След</div>
        </div>
        <div v-show="count == 0">&nbsp;</div>

        <div class="inline datepicker" valign="center" v-if="$route.name == 'parking' || $route.name == 'owner'">
            <DatePicker :value="date_from" @dateUpdate="dateUpdateFrom"></DatePicker>
            <span>&ndash;</span>
            <DatePicker :value="date_to" @dateUpdate="dateUpdateTo"></DatePicker>
        </div>

        <p>
            <span v-show="count > 0">
                <span class="count-on-page">
                    <span>Записей на странице</span>
                    <select v-model="paginator.per_page">
                        <option :value="item" v-for="(item, index) of per_page" :key="index">{{ item }}</option>
                    </select>
                </span>
                Показано {{ show_from + 1 }} &ndash; {{ show_to }}.
            </span>
            Найдено всего: {{ count }}
        </p>
    </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'

export default {
    props: ['count', 'paginator', 'show_from', 'show_to', 'date_from', 'date_to'],
    components: {
        DatePicker
    },
    data () {
        return {
            per_page: [25, 50, 100, 200, 400, 600]
        }
    },
    methods: {
        dateUpdateFrom (date) {
            this.$emit('dateUpdate', {type: 'from', date: date})
        },
        dateUpdateTo (date) {
            this.$emit('dateUpdate', {type: 'to', date: date})
        }
    }
}
</script>